<template>
    <el-header class="header">
        <h1 class="logo">巨幕</h1>
        <div class="content">
            <p class="sitename">{{ siteName }}</p>
            <el-dropdown @command="clickDropdown">
                <div class="el-dropdown-link user">
                    {{ userName }}
                    <i class="el-icon-caret-bottom" />
                </div>
                <el-dropdown-menu slot="dropdown" style="width: 150px;">
                    <el-dropdown-item :command="command.logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </el-header>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ROUTER_LOGIN } from '../../router.js';

export default {
    data() {
        return {
            command: {
                logout: 'logout',
            },
        };
    },
    computed: {
        ...mapState({
            userName: (state) => state.userInfo.userName,
        }),
        siteName() {
            return this.$route.query.siteName;
        },
    },
    methods: {
        ...mapActions(['logout']),
        async clickDropdown(command) {
            if (command === this.command.logout) {
                await this.logout();
                this.$router.push(ROUTER_LOGIN);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.header {
    display: flex;
    height: 60px;
    line-height: 60px;
    text-align: right;
    background-color: #409eff;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
        0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
    padding: 0;
    position: relative;
    z-index: 1;
}

.logo {
    width: 210px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 26px;
    color: #ffffff;
    background-color: #007cd6;
    border-right: 1px solid #006dc2;
}

.content {
    flex: 1;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
}

.sitename {
    font-size: 18px;
    color: #ffffff;
}

.user {
    color: #ffffff;
    padding: 0 20px;
    cursor: pointer;
    &:hover {
        background: rgba(0, 0, 0, 0.1);
    }
}
</style>
